import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import PageEditSelection from '../../components/PageEditSelection'
import toJS from '../../hoc/toJS'

const mapStateToProps = state => ({
    routes: state.getIn(['wpServerData', 'data', 'data', 'routes']),
    weischerConfig: state.getIn(['wpServerData', 'data', 'data', 'advertisement_config'])
})

const PageEditSelectionContainer = ({match, routes, weischerConfig}) => {
    const { selectionId, selectionType } = match.params
    const hasWeischerActive = routes ? weischerConfig && weischerConfig.weischer_main_slider ? routes.weischer : false : false 
    const hasAdvertisementsActive = routes ? routes.advertisement : false 

    return <PageEditSelection 
        selectionId={selectionId}
        selectionType={selectionType}
        hasWeischerActive={hasWeischerActive}
        hasAdvertisementsActive={hasAdvertisementsActive}
    />
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(PageEditSelectionContainer)